<template>
  <div
    class="CardElement"
    :class="{
      'row-fluid': isFluid,
      'row': (!isFluid && isFull),
      'tight': tight }">
    <div
      class="CardWrap"
      :style="{
      backgroundColor,
      backgroundImage,
      backgroundSize,
      backgroundPosition,
      backgroundRepeat,
      padding,
      'height': calculatedHeight,
      'width': calculatedWidth }"
      :class="{
        'columns': (!isFluid && !isFull),
        'small-12': (!isFluid && isFull),
        'small-6': (!isFluid && isHalf),
        'small-4': (!isFluid && isThird),
        'small-3': (!isFluid && isQuarter),
        'cardFull': isFull,
        'cardHalf': isHalf,
        'cardThird': isThird,
        'cardQuarter': isQuarter,
        'padBottom': padBottom }">
      <div class="CardOuterWrap"
        :class="{ 'row': isFluid }">
        <div
          class="CardInnerWrap"
          :class="{ 'small-12 columns': isFluid }">
          <a
            v-if="button.url"
            :href="button.url"
            class="contentBox"
            :style="calculatedStyle">
            <slot></slot>
          </a>
          <div
            v-else
            class="contentBox"
            :style="calculatedStyle">
            <slot></slot>
          </div>
        </div>
        <div class="clear"/>
      </div>
      <div class="clear"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',
  props: {
    button: {
      type: Object,
      default: function() {
        return {}
      }
    },
    size: {
      type: String,
      required: true
    },
    isFluid: {
      type: Boolean,
      default: false
    },
    tight: {
      type: Boolean,
      default: false
    },
    padBottom: {
      type: Boolean,
      default: true
    },
    padding: {
      type: String
    },
    height: {
      type: Object,
      default: function() {
        return { sm: '480px', lg: '550px' }
      }
    },
    width: {
      type: Object,
      default: function() {
        return {}
      }
    },
    contentStyle: {
      type: Object,
      default: function() {
        return { height: '420px' }
      }
    },
    backgroundImage: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    backgroundPosition: {
      type: String,
      default: 'center'
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    backgroundRepeat: {
      type: String,
      default: 'no-repeat'
    },
    label: {
      type: Object,
    },
    header: {
      type: Object,
    },
    subHeader: {
      type: Object
    }
  },
  computed: {
    isFull() {
      return this.size == 'full'
    },
    isHalf() {
      return this.size == 'half'
    },
    isThird() {
      return this.size == 'third'
    },
    isQuarter() {
      return this.size == 'quarter'
    },
    calculatedHeight() {
      if (this.height && this.height[this.$mq]) {
        return this.height[this.$mq]
      } else {
        return '550px'
      }
    },
    calculatedWidth() {
      if (this.width && this.width[this.$mq]) {
        return this.width[this.$mq]
      }
    },
    calculatedStyle() {
      if (this.contentStyle && this.contentStyle.sm && this.$mq === 'sm') {
        return { ...this.contentStyle, ...this.contentStyle.sm }
      } else if (this.contentStyle && this.contentStyle.lg && this.$mq === 'lg') {
        return { ...this.contentStyle, ...this.contentStyle.lg }
      } else {
        return this.contentStyle
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$mobileBreak: 640px;
$tabletBreak: 960px;

.CardWrap {
  position: relative;
  z-index: 1;
  overflow: hidden;

  &.padBottom {
    margin-bottom: 0.5rem;
  }
}

.row-fluid {
  .row {
    height: 100%;

    .columns {
      height: 100%;
    }
  }
}

.CardOuterWrap,
.CardInnerWrap {
  height: 100%;
  width: 100%;
  display: flex;
}

.cardFull,
.cardHalf,
.cardThird,
.cardQuarter {
  .label {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  .header {
    font-weight: bold;
    line-height: 3rem;
    margin: 0.5rem 0;
  }

  .subHeader {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.cardFull {
  width: 100%;

  .contentBox {
    padding: 1.5rem;
  }
}

.cardHalf {
  width: calc(50% - 0.25rem);
  text-align: center;

  .contentBox {
    margin: auto;
  }

  @media screen and (max-width: $tabletBreak) {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.cardThird {
  width: calc(33.313131% - 0.325rem);
  text-align: center;

  .contentBox {
    margin: auto;
  }

  @media screen and (max-width: $tabletBreak) {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.cardQuarter {
  width: calc(25% - 0.375rem);
  text-align: center;

  .contentBox {
    margin: auto;

    @media screen and (max-width: $tabletBreak) {
      position: absolute;
      top: 40%;
    }
  }

  @media screen and (max-width: $tabletBreak) {
    width: calc(50% - 0.25rem);
  }
}

.CardElement.tight {
  .cardHalf {
    width: 50%;

    @media screen and (max-width: $mobileBreak) {
      width: 100%;
      margin: 0;
    }
  }

  .cardThird {
    width: 33.33333%;

    @media screen and (max-width: $mobileBreak) {
      width: 100%;
      margin: 0;
    }
  }

  .cardQuarter {
    width: 25%;
    @media screen and (max-width: $tabletBreak) {
      width: 50%;
      margin: 0;
    }
  }
}


</style>

<style lang="scss" scoped>

</style>